const config = {

    production: {

        // REACT_APP_BASE_URL: "https://staginggateway.nucliqmicroterra.com/"
        REACT_APP_BASE_URL: "https://qa.nucliqmicroterra.com:8080/"
    },

    development: {

        // REACT_APP_BASE_URL: "https://nucliq-dev.g-axis.in:8080/"
        REACT_APP_BASE_URL: "https://qa.nucliqmicroterra.com:8080/"

    },

};

export default config;